import { Box, Icon, Text } from '@factorialco/deprecated-design-system'
import { PayrollDetailsIncidenceViewFragment } from 'generated/resources/graphql'

import i18n from 'modules/core/lib/i18n'

import { mandatoryFieldsTranslations } from 'modules/bookkeepers/lib/dynamicTranslations'

interface Props {
  ruleEvaluation: PayrollDetailsIncidenceViewFragment
}

const BasicView = ({ ruleEvaluation }: Props) => {
  return (
    <Box flexDirection="row" gap="s12">
      <Icon.Medium icon="info-circle-line" color="grey800" />
      <Box>
        <Text.Normal color="grey1000">
          {i18n.t('bookkeepers.incidence.incidence_rules.bookkeeper.header')}
        </Text.Normal>
        {ruleEvaluation.missingFields.map((missingField) => (
          <Text.Normal color="grey1000" key={missingField.field}>
            {`· ${mandatoryFieldsTranslations(missingField.field)}`}
          </Text.Normal>
        ))}
      </Box>
    </Box>
  )
}

export default BasicView
